(function (root) {
  function initOne(root_) {
    if (!root_ || root_.dataset.fhBrandIndexBound === "true") return;
    root_.dataset.fhBrandIndexBound = "true";

    var brandSearch = root_.querySelector("[data-brand-search]");
    var brandIndex = root_.querySelector("[data-brand-index]");
    if (!brandIndex) return;

    var brandItems = Array.prototype.slice.call(brandIndex.querySelectorAll("[data-brand-item]"));
    var brandGroups = Array.prototype.slice.call(brandIndex.querySelectorAll("[data-brand-group]"));
    var brandEmpty = brandIndex.querySelector("[data-brand-empty]");
    var letterButtons = Array.prototype.slice.call(root_.querySelectorAll("[data-brand-letter]"));

    var filterBrands = function () {
      var query = (brandSearch && brandSearch.value ? brandSearch.value : "").trim().toLocaleLowerCase("de");
      var activeLetterBtn = root_.querySelector("[data-brand-letter].is-active");
      var activeLetter = activeLetterBtn ? activeLetterBtn.dataset.brandLetter : "";

      brandItems.forEach(function (item) {
        var name = (item.dataset.brandItem || "").toLocaleLowerCase("de");
        var matchesQuery = !query || name.indexOf(query) !== -1;
        var matchesLetter = !activeLetter || name.indexOf(activeLetter.toLocaleLowerCase("de")) === 0;
        item.hidden = !(matchesQuery && matchesLetter);
      });

      brandGroups.forEach(function (group) {
        var visible = Array.prototype.slice.call(group.querySelectorAll("[data-brand-item]")).some(function (item) {
          return !item.hidden;
        });
        group.hidden = !visible;
      });

      var anyVisible = brandItems.some(function (item) {
        return !item.hidden;
      });
      if (brandEmpty) brandEmpty.hidden = anyVisible;
    };

    if (brandSearch) brandSearch.addEventListener("input", filterBrands);

    letterButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var wasActive = button.classList.contains("is-active");
        letterButtons.forEach(function (item) {
          item.classList.remove("is-active");
        });
        if (!wasActive) button.classList.add("is-active");
        filterBrands();
      });
    });
  }

  function initAll(scope) {
    var scopeEl = scope || root.document;
    if (!scopeEl || !scopeEl.querySelectorAll) return;
    scopeEl.querySelectorAll(".fh-brand-index").forEach(function (section) {
      initOne(section);
    });
    if (scopeEl.classList && scopeEl.classList.contains("fh-brand-index")) {
      initOne(scopeEl);
    }
  }

  root.FHBrandIndex = {
    initAll: initAll
  };

  if (root.document) {
    if (root.document.readyState === "loading") {
      root.document.addEventListener("DOMContentLoaded", function () {
        initAll(root.document);
      });
    } else {
      initAll(root.document);
    }
    root.document.addEventListener("shopify:section:load", function (event) {
      initAll(event.target);
    });
  }
})(typeof window !== "undefined" ? window : globalThis);
